import { FC } from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { StatusIcon } from 'components/Icons'
import { Link } from 'components/Link/Link'
import moment from 'moment'
import { ITalkToUsResponseDto } from 'services/NGT/TalkToUs'
import { COLORS, SPACING } from 'utils'

export interface ITableTalkToUsProps {
  tableData: ITalkToUsResponseDto[]
  page: number
  handleAnswerForm: (faleConoscoId: number) => void
  areDatesValid: () => boolean
  setPage: React.Dispatch<React.SetStateAction<number>>
  rowsPerPage: number
  totalItems: number
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>
}

const TableTalkToUs: FC<ITableTalkToUsProps> = ({
  tableData,
  page,
  handleAnswerForm,
  areDatesValid,
  rowsPerPage,
  setRowsPerPage,
  totalItems,
  setPage
}) => {
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="50px" padding="normal" align="left">
                Motivo
              </TableCellStyled>
              <TableCellStyled minwidth="80px" align="left">
                Usuário
              </TableCellStyled>
              <TableCellStyled minwidth="90px" align="left">
                E-mail
              </TableCellStyled>
              <TableCellStyled minwidth="30px" align="left">
                Hora
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Data
              </TableCellStyled>
              <TableCellStyled maxwidth="20px" align="left">
                Status
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData.map((row, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled
                    minwidth="50px"
                    padding="normal"
                    align="left"
                  >
                    <Link onClick={() => handleAnswerForm(row.idFaleConosco)}>
                      {row.txMotivo}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled minwidth="80px" align="left">
                    <Link onClick={() => handleAnswerForm(row.idFaleConosco)}>
                      {row.nmUsuario}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled minwidth="90px" align="left">
                    <Link onClick={() => handleAnswerForm(row.idFaleConosco)}>
                      {row.txEmail}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled minwidth="30px" align="left">
                    <Link onClick={() => handleAnswerForm(row.idFaleConosco)}>
                      {moment(row.dtEnvio).format('HH:mm')}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled minwidth="20px" align="left">
                    <Link onClick={() => handleAnswerForm(row.idFaleConosco)}>
                      {moment(row.dtEnvio).format('DD/MM/yyyy')}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled maxwidth="10px" align="right">
                    <Link onClick={() => handleAnswerForm(row.idFaleConosco)}>
                      <StatusIcon
                        colorIcon={
                          row.flRespondido ? COLORS.success : COLORS.gray
                        }
                        marginLeft={SPACING.spacing20}
                      />
                    </Link>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        disabled={!areDatesValid()}
        totalItems={totalItems}
        rowsPerPage={rowsPerPage}
        handleChangePage={(newPage) => setPage(newPage)}
        handleChangeRowsPerPage={(rows) => setRowsPerPage(rows.target.value)}
      />
    </>
  )
}

export default TableTalkToUs
